/** Every spoken line is English, so a Korean OS default voice must not read it. */
const VOICE_LANG = 'en-US';

/** Silent wherever the browser has no speech synthesis, which is every headless run. */
export const speak = (line: string): void => {
  const synth = window.speechSynthesis;
  const Utterance = window.SpeechSynthesisUtterance;
  if (!synth || !Utterance) {
    return;
  }
  const utterance = new Utterance(line);
  utterance.lang = VOICE_LANG;
  // Voices can still be loading on the first line; the lang alone then steers the browser's pick.
  const voices = synth.getVoices?.() ?? [];
  // Some platforms report the tag as en_US or en-us.
  const voice = voices.find((candidate) => candidate.lang.replace('_', '-').toLowerCase() === VOICE_LANG.toLowerCase());
  if (voice) {
    utterance.voice = voice;
  }
  synth.speak(utterance);
};
